import * as React from "react"
import useIntersectionObserver from "./intersectionObserver"

export default function ProvenExpert() {
  useIntersectionObserver(
    "https://www.provenexpert.com/widget/landing_nicole-susann-ranke.js?feedback=1&avatar=1&competence=1&style=white",
    "#pewl"
  )
  return <div id="pewl" />
}
